import React from "react";
import { useTheme } from "styled-components";

const Panel = () => {
  const theme = useTheme();
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clip-path="url(#a)"
        stroke={theme.text.text}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M9 16.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15M9 12V9"
          strokeWidth="1.275"
        />
        <path d="M9 6h.008" strokeWidth="1.875" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Panel;
